import development from "@FRAMEWORK/utils/partners/resize/development";
import production from "@FRAMEWORK/utils/partners/resize/production";
import publicConfig from "@FRAMEWORK/config/public";

export default () => {
	const mode = publicConfig.RUNTIME_ENV;
	return mode === "production" ? production : development;
};
